import { CheckForApplicationUpdate, LayoutProps, Layout as RALayout } from 'react-admin';
import { AppLocationContext } from '@react-admin/ra-navigation';
import AppBar from './AppBar';
import { ReactElement } from 'react';
import Menu from './Menu';
import { ExportAllProvider } from '../Resources/Click/ExportAll';

export default function Layout({ children, ...props }: LayoutProps): ReactElement {
  return (
    <AppLocationContext>
      <ExportAllProvider>
        <RALayout {...props} appBar={AppBar} menu={Menu}>
          {children}
          <CheckForApplicationUpdate />
        </RALayout>
      </ExportAllProvider>
    </AppLocationContext>
  );
}
